const CHECK_NEW_VERSION_INTERVAL = 30 * 1000;
const TIMER_NAME = 'timer-new-version-available';

export const checkNewVersionAvailable = (batchStore) => {
  if (window.newVersionAvailable) {
    batchStore.newVersionAvailable = true;
  }

  batchStore.clearTimeout(batchStore[TIMER_NAME]);
  batchStore[TIMER_NAME] = batchStore.setTimeout(() => {
    checkNewVersionAvailable(batchStore);
  }, CHECK_NEW_VERSION_INTERVAL);
};
